import { StyleEntry } from 'Shared/backend/styleUtils';


export function footerStyles(sizes,text): {[name: string]: StyleEntry}
{
	return {
		'Hide': {
			explanation: 'Hides the page footer.',

			rules: [{
				location: () => ['footer'],
				hide: () => true
			}]
		},
	};
}

